// routes for WorkSchedulePrint
import { AppRouteProps } from '~/routes';
import Index from './pages/Index';
import Create from './pages/Create';
import Edit from './pages/Edit';

export default function ResourcesEquipamentsGroupRoutes(): readonly AppRouteProps[] {
  const routes: readonly AppRouteProps[] = [
    {
      path: '/equipment-group',
      component: Index,
      isProtected: true,
      permissions: ['equipment_group_index'],
    },
    {
      path: '/equipment-group/create',
      component: Create,
      isProtected: true,
      permissions: ['equipment_group_create'],
    },
    {
      path: '/equipment-group/edit/:id',
      component: Edit,
      isProtected: true,
      permissions: ['equipment_group_edit'],
    },
  ];

  return routes;
}